import React, { useState } from 'react';
import HROverview from './HROverview';
import OrgChart from './OrgChart';
import StaffDirectory from './StaffDirectory';
import TimeOff from './TimeOff';
import Onboarding from './Onboarding';
import PreOnboarding from './PreOnboarding';

const NAVY = '#1A3A5C';
const ORANGE = '#EA6F2E';

// The Human Resources hub — one top-level page with an internal tab bar. Each tab
// renders the existing module; Overview is a role-aware roll-up. Tab visibility
// preserves the prior sidebar gating (Openings/Onboarding are admin + designated).
export default function HumanResources({ currentUser, navigateTo, pendingCaseId, onCaseOpened, onOpenChat }) {
  // role is normalized to 'admin' for all elevated tiers (owner/admin/supervisor).
  // For now they get Openings + Onboarding; staff get the other 4 HR tabs.
  const isAdmin = currentUser?.role === 'admin';
  const canOpenings = isAdmin;
  const canOnboarding = isAdmin;

  const tabs = [
    { key: 'overview',        label: 'Overview',         show: true },
    { key: 'openings',        label: 'Openings',         show: canOpenings },
    { key: 'onboarding',      label: 'Onboarding',       show: canOnboarding },
    { key: 'org-chart',       label: 'Org Chart',        show: true },
    { key: 'staff-directory', label: 'Staff Directory',  show: true },
    { key: 'time-off',        label: 'Time Off / Leave', show: true },
  ].filter(t => t.show);

  const [tab, setTab] = useState('overview');

  const renderTab = () => {
    switch (tab) {
      case 'overview':        return <HROverview currentUser={currentUser} onNavigateTab={setTab} />;
      case 'openings':        return <PreOnboarding isAdmin={isAdmin} navigateTo={navigateTo} />;
      case 'onboarding':      return <Onboarding isAdmin={isAdmin} currentUser={currentUser} openCaseId={pendingCaseId} onCaseOpened={onCaseOpened} onOpenChat={onOpenChat} />;
      case 'org-chart':       return <OrgChart currentUser={currentUser} />;
      case 'staff-directory': return <StaffDirectory currentUser={currentUser} />;
      case 'time-off':        return <TimeOff currentUser={currentUser} />;
      default:                return null;
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '2px', padding: '0 28px', borderBottom: '1px solid #EDEDF0', background: '#fff' }}>
        {tabs.map(t => {
          const active = tab === t.key;
          return (
            <button
              key={t.key}
              onClick={() => setTab(t.key)}
              style={{
                padding: '15px 16px', border: 'none', background: 'none', cursor: 'pointer',
                fontSize: '14px', fontWeight: active ? 700 : 500, color: active ? NAVY : '#8A8A8E',
                borderBottom: active ? `2.5px solid ${ORANGE}` : '2.5px solid transparent',
                whiteSpace: 'nowrap', marginBottom: '-1px', transition: 'color .15s',
              }}
            >
              {t.label}
            </button>
          );
        })}
      </div>

      {/* Overview gets page padding; the other tabs are full modules that self-pad. */}
      <div style={{ padding: tab === 'overview' ? '24px 28px' : 0 }}>
        {renderTab()}
      </div>
    </div>
  );
}
